import React from 'react';
import './Card.css';

function Card({ className = '', children, ...props }) {
  return (
    <div className={`cw-card${className ? ` ${className}` : ''}`} {...props}>
      {children}
    </div>
  );
}

export default Card;
